import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { IListRequest } from "interfaces/list-duck";
import { requestErrorHandler } from "utils";
import { ListJustificationsActions } from "store/ducks/settings/justifications";

import { Justification } from "interfaces/justification";

export function* listJustificationsRequest(action: any) {
  try {
    const { query = {}, onSuccess } = action as IListRequest;
    const queryString = queryBuilder(query);
    const { data } = yield call(api.get, `/justifications?${queryString}`);
    const comboOptions = data.map((justification: Justification) => ({
      value: justification.id,
      label: justification.name,
    }));

    yield put(ListJustificationsActions.success(comboOptions));
    if (onSuccess) onSuccess(comboOptions);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListJustificationsActions.failure(errorMessage));
  }
}
